import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

export default function RouteChangeReporter() {
  const location = useLocation();

  useEffect(() => {
    const page_path = location.pathname + location.search;

    // Ako se koristi GTM, gurni event u dataLayer (GA4/Ads page_view tagovi u GTM-u neka slušaju).
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "virtual_page_view",
        page_path,
      });
    }

    // Ako se koristi gtag-u (bez GTM), ovo će pokriti GA4 + Ads:
    if (window.gtag) {
      window.gtag("config", "G-QHJ6WW9BLY", { page_path });
      window.gtag("config", "G-HJVFB3CZ1E", { page_path });
      window.gtag("config", "AW-11053623251", { page_path });
    }
  }, [location]);

  return null;
}
